import {NgModule} from '@angular/core';
import {PaginatorComponent} from "@iw-shop/core/components/paginator/paginator.component";
import {CommonModule, NgClass, NgForOf, NgIf} from "@angular/common";
import {ClickOutsideDirective} from "@iw-shop/core/directives/click-outside.directive";
import {InjectHTMLDirective} from "@iw-shop/core/directives/inject-html.directive";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ScrollToTopComponent} from "@iw-shop/core/components/scroll-to-top/scroll-to-top.component";
import {ToastModule} from "primeng/toast";
import {NotificationsHandlerComponent} from "@iw-shop/core/components/notifications-handler/notifications-handler.component";
import {ButtonModule} from "primeng/button";
import {
    NotificationContentComponent
} from "@iw-shop/core/components/notification-content/notification-content.component";
import {RemoveElementOnSsrDirective} from "@iw-shop/core/directives/remove-element-on-ssr.directive";
import {
    CaptchaWithoutCaptchaComponent
} from "@iw-shop/captcha/componments/captcha-without-captcha/captcha-without-captcha.component";
import {RouterLink} from "@angular/router";

@NgModule({
    declarations: [
        PaginatorComponent,
        ClickOutsideDirective,
        InjectHTMLDirective,
        ScrollToTopComponent,
        NotificationsHandlerComponent,
        NotificationContentComponent,
        RemoveElementOnSsrDirective,
        CaptchaWithoutCaptchaComponent,
    ],
    imports: [
        NgIf,
        NgForOf,
        FontAwesomeModule,
        NgClass,
        ToastModule,
        ButtonModule,
        CommonModule,
        RouterLink

    ],
    exports: [
        PaginatorComponent,
        ClickOutsideDirective,
        InjectHTMLDirective,
        ScrollToTopComponent,
        NotificationsHandlerComponent,
        RemoveElementOnSsrDirective,
        CaptchaWithoutCaptchaComponent,
    ]
})
export class CoreModule {
}
